<template>
  <b-button
    v-bind="$attrs"
    v-on="$listeners"
    :variant="computedVariant"
    :class="`mc-button mc-btn__${variant} ${computedClass}`"
    :disabled="disabled"
  >
    <!-- Todo: add slot for upcoming feature -->
    <i v-if="icon && iconPosition === 'left'" :class="`mc-icon ${icon}`"></i>
    {{ text }}
    <i v-if="icon && iconPosition === 'right'" :class="`mc-icon ${icon}`"></i>
  </b-button>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Button',
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
    },
    icon: {
      type: String,
    },
    iconPosition: {
      type: String,
      default: 'left',
    },
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    computedVariant() {
      const defaultVariant = 'primary'
      const variantMapping = {
        secondary: 'outline-primary',
        minimal: 'outline-primary',
        'secondary-red': 'outline-danger',
      }

      return variantMapping[this.variant] || defaultVariant
    },
    computedClass() {
      const buttonClasses = []
      if (this.icon && !this.text) buttonClasses.push('mc-btn__icon')
      if (this.size) buttonClasses.push(`mc-btn__${this.size}`)

      return buttonClasses.join(' ')
    },
  },
}
</script>
<style lang="scss" scoped>
.mc-button {
  display: flex;
  gap: 8px;
  padding: 8px 16px 8px 16px;

  .mc-icon:before {
    font-size: 20px;
  }

  &.mc-btn__icon {
    padding: 8px;
  }
  &.mc-btn__small,
  &.mc-btn__sm {
    gap: 4px;
    padding: 4px 8px 4px 8px;
    border-radius: 3px;

    &.mc-btn__icon {
      padding: 4px;
    }

    .mc-icon:before {
      font-size: 16px;
    }
  }

  &.mc-btn__primary {
    .mc-icon:before {
      color: $white;
    }

    &:disabled {
      color: $mep-color-text-200;
      background-color: $gray;
      border-color: transparent;

      .mc-icon:before {
        color: $mep-color-text-200;
      }
    }

    &:focus {
      outline: 2px solid $mep-primary-200 !important;
    }
  }

  &.mc-btn__secondary {
    .mc-icon:before {
      color: $mep-primary;
    }

    &:hover,
    &:active,
    &:focus {
      color: $white;
      background-color: $mep-primary;

      .mc-icon:before {
        color: $white;
      }
    }

    &:focus {
      outline: 2px solid $mep-primary-200 !important;
    }

    &:disabled {
      color: $mep-color-text-200;
      background-color: $white;
      border-color: $mep-color-text-200;

      .mc-icon:before {
        color: $mep-color-text-200;
      }
    }
  }

  &.mc-btn__secondary-red {
    .mc-icon:before {
      color: $red;
    }

    &:hover,
    &:focus {
      .mc-icon:before {
        color: $white;
      }
    }

    &:disabled {
      color: $mep-color-text-200;
      background-color: $white;
      border-color: $mep-color-text-200;

      .mc-icon:before {
        color: $mep-color-text-200;
      }
    }
  }

  &.mc-btn__minimal {
    border-color: transparent;

    .mc-icon:before {
      color: $mep-primary;
    }

    &:hover {
      color: $mep-primary;
      background-color: $gray;

      .mc-icon:before {
        background-color: $gray;
      }
    }

    &:disabled {
      color: $mep-color-text-200;
      background-color: transparent;

      .mc-icon:before {
        color: $mep-color-text-200;
      }
    }

    &:focus {
      outline: 2px solid $mep-primary-200 !important;
      background-color: transparent;

      .mc-icon:before {
        background-color: transparent;
      }
    }
  }
}
</style>
